import { useCallback } from 'react';
import { getSession, getGetWpTokenQueryOptions, queryClient } from '@onesource/services';
import { useFullscreenLoader } from '@onesource/components';
import { openUrl, isSafari, injectPreloaderInTab } from '@onesource/utils';
import { WP_MEMBERS_SITE } from 'src/config';

export const useClassicAreaLink = (self = false) => {
  const { showLoader, hideLoader } = useFullscreenLoader();

  const token = getSession();
  const payload = token ? JSON.parse(atob(token.split('.')[1])) : null;
  const payloadWpToken = payload?.wp_token as string | undefined;

  const getWpToken = useCallback(async (): Promise<string | undefined> => {
    if (payloadWpToken) {
      return payloadWpToken;
    }
    const { token: wpToken } = await queryClient.ensureQueryData(getGetWpTokenQueryOptions({}));
    return wpToken;
  }, [payloadWpToken]);

  const handleClassicPanelClick = useCallback(
    async (redirectUrlParam?: string) => {
      const destination = redirectUrlParam ? redirectUrlParam : WP_MEMBERS_SITE;
      const redirectPath = destination.startsWith(WP_MEMBERS_SITE) ? destination : `${WP_MEMBERS_SITE}${destination}`;

      if (self || isSafari()) {
        showLoader({ title: 'Taking you to the Classic Area', subtitle: 'This will only take a moment...' });
        try {
          const wpToken = await getWpToken();
          const fullAuthRedirectUrl = `${WP_MEMBERS_SITE}/verify-token?token=${wpToken}&redirect_url=${encodeURIComponent(redirectPath)}&wp_token=true`;
          openUrl(fullAuthRedirectUrl, { sameTab: true });
        } finally {
          hideLoader();
        }
        return;
      }

      const newTab = window.open('', '_blank');

      if (newTab) {
        injectPreloaderInTab(newTab);
      }

      try {
        showLoader({
          title: 'Taking you to the Classic Area',
          subtitle: 'This will only take a moment...',
        });

        const wpToken = await getWpToken();
        const verifyTokenUrl = `${WP_MEMBERS_SITE}/verify-token?token=${wpToken}&redirect_url=${encodeURIComponent(redirectPath)}&wp_token=true`;
        if (newTab) {
          newTab.location.href = verifyTokenUrl;
        }
      } catch {
        newTab?.close();
      } finally {
        hideLoader();
      }
    },
    [self, showLoader, hideLoader, getWpToken],
  );

  return { handleClassicPanelClick };
};
